module.exports = __webpack_public_path__ + "img/9788925535104.d02bace9.jpg";